export enum MasterType {
    Unknown = 0,
    Simulation = 1,
    IFM = 100,
    Turck = 200,
}
